module.exports = __webpack_public_path__ + "static/media/fq_line-9.32107551.png";